var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBar3D(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6189 50.9543L30.223 51.711L30.426 7.33153L22.5957 6.83545L22.6189 50.9543Z",
    fill: "#86B5FD",
    stroke: "#86B5FD",
    strokeWidth: 0.368817,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.426 7.3315L33.4021 4.46026L25.8407 4L22.5957 6.83542L30.426 7.3315Z",
    fill: "#5296FC",
    stroke: "#86B5FD",
    strokeWidth: 0.368817,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4256 7.3317L30.2227 51.7111L33.1231 47.3279L33.4017 4.46045L30.4256 7.3317Z",
    fill: "#5296FC",
    stroke: "#86B5FD",
    strokeWidth: 0.368817,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2165 51.287L46.8207 51.7103L47.0237 26.8854L39.1934 26.6079L39.2165 51.287Z",
    fill: "#A2E9F3",
    stroke: "#A2E9F3",
    strokeWidth: 0.368817,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0237 26.8855L49.9997 25.2794L42.4383 25.022L39.1934 26.608L47.0237 26.8855Z",
    fill: "#7AE0EE",
    stroke: "#A2E9F3",
    strokeWidth: 0.368817,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0233 26.8854L46.8203 51.7103L49.7207 49.2584L49.9994 25.2793L47.0233 26.8854Z",
    fill: "#7AE0EE",
    stroke: "#A2E9F3",
    strokeWidth: 0.368817,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.02317 51.1178L13.6273 51.7107L13.8303 16.937L6 16.5483L6.02317 51.1178Z",
    fill: "#BBB1F0",
    stroke: "#BBB1F0",
    strokeWidth: 0.368817,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8303 16.9371L16.8064 14.6873L9.24498 14.3267L6 16.5484L13.8303 16.9371Z",
    fill: "#9E8FE9",
    stroke: "#BBB1F0",
    strokeWidth: 0.368817,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8299 16.9373L13.627 51.7109L16.5274 48.2764L16.806 14.6875L13.8299 16.9373Z",
    fill: "#9E8FE9",
    stroke: "#BBB1F0",
    strokeWidth: 0.368817,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBar3D);
export default __webpack_public_path__ + "static/media/bar3d.6b5dc595427cdfa9e18b5619ff7c2055.svg";
export { ForwardRef as ReactComponent };